<template>
	<div class="idleNone">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>我的店铺</span>
			<span @click="update" v-if="isNone==false">编辑</span>
			<span v-else></span>
		</div>
		<!-- 暂无数据 -->
		<div class="isNone" v-if="isNone">
			<div>您的产品还没有入驻俱百家哦~</div>
			<van-button size="mini" style="width: 20%;" color="#F1452F" to="/Shop" round>立即入驻</van-button>
		</div>
		<div v-else>
			<!-- 店铺详情 -->
			<div v-if="obj.image === undefined"></div>
			<div class="chain" v-else>
				<!-- 店铺信息 -->
				<div class="list">
					<van-card>
						<div slot="title" class="list_title">
							<div>{{obj.title}}</div>
						</div>
						<div slot="desc" class="list_desc">
							<div>{{obj.business}}</div>
							<!-- 店铺图片信息 -->
							<div class="swiper_img">
								<ul>
									<li v-for="item in obj.image">
										<img :src="item | handleUrl"></img>
									</li>
								</ul>
							</div>
						</div>
						<div slot="tags" class="list_tags">
							<div>
								<van-tag color="#F1452F" round v-if="obj.category === 1">个体</van-tag>
								<van-tag color="#F1452F" round v-else>公司</van-tag>
								<van-tag color="#F1452F" round>已认证</van-tag>
							</div>
							<div></div>
						</div>
						<div slot="price-top" class="list_priceTop">
							<div class="list_priceTop_left">
								<div>总评分</div>
								<div class="star">{{obj.fraction}}</div>
								<van-rate v-model="obj.fraction/2" :allow-half="true" color="#F1452F" size="0.8rem" readonly />
							</div>
							<div class="list_priceTop_right" @click="callPhone(obj.tel)">
								<van-icon name="phone" size="1.5rem" />
								<div>
									<span>
										{{obj.tel | phoneNumFilter}}
									</span>
									<span>免费咨询</span>
								</div>
							</div>
						</div>
						<div slot="bottom" class="list_bottom">
							<van-icon name="location-o" />
							<div>&nbsp;{{obj.province}}{{obj.city}}{{obj.area}}{{obj.address}}</div>
						</div>
					</van-card>
				</div>
				<!-- 业务详情 -->
				<van-panel title="店铺详情">
					<div>
						<div>{{obj.content}}</div>
						<img :src="item | handleUrl" alt="" v-for="item in obj.slider_image ">
					</div>
				</van-panel>
				<!-- 俱百家提醒您 -->
				<div class="serve">
					<div>俱百家提醒您</div>
					<p>
						办理业务前请勿提前支付款项，付款请认真审核商家资质，
						显示已认证的商户为俱百家平台审核过的商户，显示官方推荐的商户为平台有押金的商户请放心使用，
						为了保证您的合法权益三次差评的商户我们立即做下架处理。您的每一次认真的评价就是对我们商户成长的一次历练谢谢您的理解与支持！400-8722-000
					</p>
				</div>
				<div class='tip'>
					如遇虚假、诈骗信息或服务纠纷，请立即举报服务过程请注意保存证据，谨防诈骗.<span @click="callPhone('400-8722-000')">立即投诉</span>
				</div>
				<van-goods-action>
					<van-goods-action-icon icon="wap-home-o" text="首页" to="/Home" />
					<van-goods-action-icon icon="like-o" text="收藏" @click="onClickIconn" />
					<van-goods-action-button type="danger" text="拨打电话" @click="callPhone(obj.tel)" />
				</van-goods-action>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				active: 0,
				current: 0, //轮播图指示器
				obj: '',
				isNone: true
			}
		},
		created() {
			this.$axios.post(baseUrl + '/mobile/Category/thirdpartyUser', {
				token: localStorage.getItem('Authorization')
			}).then((res) => {
				if (res.data.code === 2) {
					this.obj = res.data.data;
					this.isNone = false;
				} else {
					this.isNone = true;
				}
			}).catch((err) => {})
		},
		methods: {
			// 调用拨号功能
			callPhone(phoneNumber) {
				window.location.href = 'tel://' + phoneNumber
			},
			//编辑
			update() {
				this.$router.push({
					path: '/ShopUpdate',
					query: {
						id: this.obj.id
					}
				})
			},
			//收藏信息
			onClickIconn() {
				this.whatLogin((bool) => {
					if (bool) {
						this.$axios.post(baseUrl + '/mobile/Base/goodsCollection', {
							id: this.$route.query.id,
							token: localStorage.getItem('Authorization')
						}).then((res) => {
							if (res.data.code == 15) {
								this.$toast(res.data.msg);
								this.collection = !this.collection;

							} else if (res.data.code == 17) {
								this.$toast(res.data.msg);
								this.collection = !this.collection;
							}
							this.shokaiww = false
						}).catch((err) => {
							console.log(err);
						})
					} else {
						this.isLogin = true;
					}
				})
			},
		},

	}
</script>

<style scoped>
	@import '../class/chain.css';

	.idleNone .isNone {
		margin-top: 4rem;
		font-size: 0.8rem;
		color: #7D7D7D;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.idleNone .isNone button {
		margin-top: 1rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/idleNone.vue